export const SUPPORTS_ARRAY_PROTOTYPE_INDEX_OF = "indexOf" in Array.prototype;
